import { useToken } from '@phonepe/enigma-ui';
import { useEffect } from 'react';
import { Token } from '@shared/types';
import { merge } from 'lodash';
import { injectCssTokens, removeCssTokens } from '../../../themes/themeUtils';

export const useEnigmaThemeProvider = (tokens: Token) => {
	const parentTokens = useToken();
	const mergedTokens = merge({}, parentTokens, tokens);

	useEffect(() => {
		injectCssTokens(mergedTokens);

		return () => {
			removeCssTokens();
		};
	}, [mergedTokens]);

	return {
		mergedTokens,
	};
};
